<template>
  <div
    class="back"
    @click="itemClick()"
    :style="{
      borderStyle: isAppSquare ? 'none' : 'solid',
    }"
  >
    <img :src="info.img" class="icon" />
    <div class="rightArea">
      <p class="itemTitle">{{ info.title }}</p>
      <p class="itemDes">{{ info.content }}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    isAppSquare: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {},
  mounted() {},
  methods: {
    itemClick() {
      this.$emit("itemClick", this.info);
    },
  },
};
</script>
<style lang="scss" scoped>
.back {
  border-radius: 10px;
  border-width: 1px;
  border-color: #ebebeb;
  border-style: solid;
  width: 260px;
  height: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  // margin-bottom: 24px;
  margin: 12px;
  flex: 0 0 18%;
  overflow: hidden;
  background-color: #ffffff;
}
.icon {
  margin-left: 24px;
  width: 28px;
  height: 28px;
  margin-right: 24px;
}
.rightArea {
  height: 100%;
}
.itemTitle {
  color: #000000;
  font-size: 14px;
  line-height: 20px;
  margin: 0px;
  text-align: left;
  margin-top: 13px;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  margin-right: 10px;
}
.itemDes {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: left;
  color: #97999b;
  font-size: 14px;
  line-height: 20px;
  margin-right: -24px;
  word-break: break-all;
  margin: 0px;
  margin-right: 20px;
}
@media screen and (max-width: 768px) {
  .back {
    border-radius: 10px;
    border-width: 1px;
    border-color: #ebebeb;
    border-style: solid;
    // width: 260px;
    height: 90px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    // margin-bottom: 24px;
    margin: 4px;
    flex: 0 0 47%;
    overflow: hidden;
    background-color: #ffffff;
  }
  .icon {
    margin-left: 12px;
    width: 28px;
    height: 28px;
    margin-right: 12px;
  }
  .rightArea {
    height: 100%;
  }
  .itemTitle {
    color: #000000;
    font-size: 13px;
    line-height: 20px;
    margin: 0px;
    text-align: left;
    margin-top: 13px;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin-right: 10px;
  }
  .itemDes {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align: left;
    color: #97999b;
    font-size: 10px;
    line-height: 20px;
    margin-right: -24px;
    word-break: break-all;
    margin: 0px;
    margin-right: 20px;
  }
}
</style>
